import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { serverSide } from 'libs/utils/environment';
import RequestContext from './RequestContext';
import { jsx as _jsx } from "react/jsx-runtime";

const NextRequestProvider = _ref => {
  let {
    children,
    locationUrl
  } = _ref;
  // Value of this state isn't needed a goal is only to trigger rerender
  // eslint-disable-next-line react/hook-use-state
  const {
    1: setRefresh
  } = useState(false);
  const {
    back,
    push,
    replace,
    query
  } = useRouter();
  const pushRef = useRef(push);
  const replaceRef = useRef(replace);
  pushRef.current = push;
  replaceRef.current = replace;
  const historyFunctions = useMemo(() => ({
    push: url => pushRef.current(url, undefined, {
      shallow: true
    }),
    replace: url => replaceRef.current(url, undefined, {
      shallow: true
    }),
    refreshUrl: () => setRefresh(prevState => !prevState)
  }), []);
  const url = serverSide ? locationUrl : window.location.href;
  const value = useMemo(() => ({
    location: _objectSpread(_objectSpread({}, historyFunctions), {}, {
      url,
      urlParams: query,
      back
    })
  }), [back, historyFunctions, query, url]);
  return /*#__PURE__*/_jsx(RequestContext.Provider, {
    value: value,
    children: children
  });
};

export default NextRequestProvider;